export const ROLE_LABELS = {
  admin: "Administrateur principal",
  ceo: "CEO",
  directeur: "Directeur / Directrice",
  directeur_adjoint: "Directeur adjoint / Directrice adjointe",
  attache_clientele: "Attaché(e) clientèle",
  partenaire: "Partenaire externe",
  infirmier_chef: "Infirmier / Infirmière en chef",
  infirmier_chef_adjoint: "Infirmier / Infirmière en chef adjoint(e)",
  referent_incontinence: "Référent(e) incontinences",
  coordinateur_soins: "Coordinateur / Coordinatrice des soins",
  directeur_vie_sociale: "Directeur / Directrice vie sociale",
  coordinateur_vie_sociale: "Coordinateur / Coordinatrice vie sociale",
  // Rôles professionnels restreints (Planning activité + Agenda)
  kine: "Kinésithérapeute",
  logopede: "Logopède",
  ergo: "Ergothérapeute",
  animateur: "Animateur / Animatrice",
  educateur: "Éducateur / Éducatrice",
  educateur_specialise: "Éducateur(trice) spécialisé(e)",
  psychomotricien: "Psychomotricien(ne)",
  psychologue: "Psychologue",
  dieteticien: "Diététicien(ne)",
  referent_demence: "Référent(e) démence",
  infirmier: "Infirmier / Infirmière",
  aide_soignant: "Aide-soignant(e)",
  assistant_social: "Assistant(e) social(e)",
  medecin: "Médecin",
  responsable_unite: "Responsable d'unité",
  autre_pro: "Autre (personnel)",
  // Rôles cuisine (accès uniquement au module Cuisine + Messagerie)
  chef_service_alimentation: "Chef(fe) de service alimentation",
  commis_cuisine: "Commis de cuisine (H/F)",
  chef_cuisinier: "Chef cuisinier / Cheffe cuisinière",
  referent_alimentation: "Référent(e) alimentation",
};

export const GROUP_TYPES = { prive: "Privé", public: "Public", asbl: "ASBL", autre: "Autre" };
export const GROUP_TYPE_STYLE = {
  prive: { text: "#c4b5fd", bg: "rgba(139,92,246,0.16)" },
  public: { text: "#7dd3fc", bg: "rgba(14,165,233,0.16)" },
  asbl: { text: "#86efac", bg: "rgba(34,197,94,0.16)" },
  autre: { text: "#cbd5e1", bg: "rgba(148,163,184,0.16)" },
};


// Rôles à accès complet (tous les onglets sauf Utilisateurs)
export const FULL_ACCESS_ROLES = ["ceo", "directeur", "directeur_adjoint"];
// Rôles vie sociale : périmètre GROUPE + menu pro (Agenda, Planning, Vie sociale, Messagerie, Guide)
export const SOCIAL_LIFE_ROLES = ["directeur_vie_sociale", "coordinateur_vie_sociale"];
// Rôles à périmètre GROUPE (voient toutes les maisons de leur groupe + sélecteur de maison)
export const GROUP_WIDE_ROLES = ["ceo", "attache_clientele", ...SOCIAL_LIFE_ROLES];
// Rôles en lecture seule (consultation + exports uniquement, aucune écriture)
export const READ_ONLY_ROLES = ["ceo"];
// Rôle commercial : accès uniquement à Tableau de bord + Agenda + Suivi commercial
export const COMMERCIAL_ROLES = ["attache_clientele"];
export const COMMERCIAL_PATHS = ["/", "/agenda", "/suivi-commercial"];
// Rôles soins : accès uniquement à Résidents + Protections incontinence
export const CARE_ROLES = ["infirmier_chef", "infirmier_chef_adjoint", "referent_incontinence", "coordinateur_soins"];
export const CARE_PATHS = ["/residents", "/incontinence"];
// Rôles ayant accès à la Formation du personnel : uniquement direction
export const FORMATION_ROLES = ["directeur", "directeur_adjoint"];
// Rôle partenaire externe : accès uniquement à l'Espace Partenaires (chambres disponibles)
export const PARTNER_ROLES = ["partenaire"];
// Rôles professionnels restreints : accès UNIQUEMENT à Planning activité + Agenda (+ droits par exception)
export const PROFESSIONAL_ROLES = [
  "kine", "logopede", "ergo", "animateur", "educateur", "educateur_specialise",
  "psychomotricien", "psychologue", "dieteticien", "referent_demence",
  "infirmier", "aide_soignant", "assistant_social", "medecin", "responsable_unite", "autre_pro",
];
// Rôles cuisine : accès UNIQUEMENT au module Cuisine (+ Messagerie)
export const KITCHEN_ROLES = ["chef_service_alimentation", "commis_cuisine", "chef_cuisinier", "referent_alimentation"];
// Rôles professionnels ayant AUSSI accès au module Cuisine (en plus de leur menu habituel)
export const CUISINE_PRO_ROLES = ["logopede", "ergo", "dieteticien", "aide_soignant", "infirmier"];
// Entrées de menu du module Cuisine
export const CUISINE_ITEMS = [
  { to: "/cuisine-agenda", label: "cuisineAgenda", icon: "CalendarDays", color: "#f97316" },
  { to: "/menu-plats", label: "menuPlats", icon: "BookOpen", color: "#f59e0b" },
  { to: "/menu-semaine", label: "menuSemaine", icon: "UtensilsCrossed", color: "#e11d48" },
  { to: "/petit-dejeuner", label: "petitDejeuner", icon: "Coffee", color: "#a16207" },
  { to: "/repas-preparation", label: "repasPreparation", icon: "Utensils", color: "#0891b2" },
  { to: "/habitants", label: "habitants", icon: "BedDouble", color: "#14b8a6" },
  { to: "/stats-repas", label: "statsRepas", icon: "BarChart3", color: "#2dd4bf" },
  { to: "/cuisine-inventaire", label: "cuisineInventaire", icon: "Boxes", color: "#0d9488" },
];
// Liste des fonctions professionnelles (pour l'auto-remplissage du planning)
export const PROFESSIONAL_FUNCTIONS = [
  "Kinésithérapeute", "Logopède", "Ergothérapeute", "Animateur / Animatrice",
  "Éducateur / Éducatrice", "Éducateur(trice) spécialisé(e)", "Psychomotricien(ne)",
  "Psychologue", "Diététicien(ne)", "Référent(e) démence", "Infirmier / Infirmière",
  "Aide-soignant(e)", "Assistant(e) social(e)", "Médecin", "Responsable d'unité",
  "Coordinateur / Coordinatrice vie sociale", "Directeur / Directrice vie sociale", "Autre",
];

// Fonctions professionnelles traduites (FR / NL / EN). La valeur stockée = FR canonique.
export const FUNCTIONS_I18N = [
  { fr: "Kinésithérapeute", nl: "Kinesitherapeut", en: "Physiotherapist", a: ["kinesitherapeute", "kine"] },
  { fr: "Logopède", nl: "Logopedist", en: "Speech therapist", a: ["logopede"] },
  { fr: "Éducateur", nl: "Opvoeder", en: "Educator", a: ["educateur / educatrice", "educateur", "educatrice"] },
  { fr: "Éducateur spécialisé", nl: "Gespecialiseerd opvoeder", en: "Specialised educator", a: ["educateur(trice) specialise(e)", "educateur specialise"] },
  { fr: "Ergothérapeute", nl: "Ergotherapeut", en: "Occupational therapist", a: ["ergotherapeute", "ergo"] },
  { fr: "Animateur", nl: "Animator", en: "Activity coordinator", a: ["animateur / animatrice", "animatrice", "animation"] },
  { fr: "Référent pour la démence", nl: "Referentiepersoon dementie", en: "Dementia officer", a: ["referent(e) demence", "referent demence", "referent(e) dementia"] },
  { fr: "Psychologue", nl: "Psycholoog", en: "Psychologist", a: [] },
  { fr: "Psychomotricien", nl: "Psychomotorisch therapeut", en: "Psychomotor therapist", a: ["psychomotricien(ne)"] },
  { fr: "Diététicien", nl: "Diëtist", en: "Dietitian", a: ["dieteticien(ne)", "dieteticienne"] },
  { fr: "Aide-soignant", nl: "Zorgkundige", en: "Care assistant", a: ["aide-soignant(e)", "aide soignant", "aide-soignante"] },
  { fr: "Assistant social", nl: "Maatschappelijk assistent", en: "Social worker", a: ["assistant(e) social(e)", "assistante sociale"] },
  { fr: "Médecin", nl: "Arts", en: "Physician", a: ["medecin"] },
  { fr: "Responsable d'unité", nl: "Afdelingsverantwoordelijke", en: "Unit manager", a: ["responsable d'unite", "responsable unite"] },
  { fr: "Coordinateur / Coordinatrice vie sociale", nl: "Coördinator sociaal leven", en: "Social life coordinator", a: ["coordinateur vie sociale", "coordinatrice vie sociale", "coordinateur / coordinatrice vie sociale"] },
  { fr: "Directeur / Directrice vie sociale", nl: "Directeur sociaal leven", en: "Social life director", a: ["directeur vie sociale", "directrice vie sociale", "directeur / directrice vie sociale"] },
];
const _fnorm = (s) => (s || "").toString().trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
const _FN_INDEX = {};
FUNCTIONS_I18N.forEach((e) => { [e.fr, e.nl, e.en, ...(e.a || [])].forEach((k) => { _FN_INDEX[_fnorm(k)] = e; }); });
export const functionOptions = (lng = "fr") => FUNCTIONS_I18N.map((e) => ({ value: e.fr, label: e[lng] || e.fr }));
export const functionLabel = (value, lng = "fr") => { if (!value) return ""; const e = _FN_INDEX[_fnorm(value)]; return e ? (e[lng] || e.fr) : value; };
export const functionToFr = (value) => { if (!value) return ""; const e = _FN_INDEX[_fnorm(value)]; return e ? e.fr : value; };

// Module Planning activité (nav des rôles pro)
export const PLANNING_MODULE = { to: "/planning-activite", label: "Planning activité", icon: "CalendarDays", color: "#8b5cf6" };
export const MESSAGERIE_ITEM = { to: "/messagerie", label: "Messagerie", icon: "MessageCircle", color: "#0ea5e9" };
// Domaines de vie PP (vocabulaire partagé activités × objectifs). Miroir du seed backend (administrable ensuite).
export const PP_DOMAINS = [
  "Mobilité & autonomie physique", "Vie sociale & relationnelle", "Cognition & mémoire",
  "Bien-être émotionnel", "Santé & soins", "Alimentation & plaisir de la table",
  "Sens & spiritualité", "Loisirs, culture & créativité", "Communication",
  "Orientation & repères", "Estime de soi & identité", "Maintien des habitudes de vie",
  "Liens familiaux", "Participation citoyenne & choix de vie",
];
// Modules qu'un admin peut accorder par exception à un rôle pro (droits par exception)
export const EXTRA_GRANTABLE_MODULES = [
  { to: "/", label: "Tableau de bord" },
  { to: "/residents", label: "Résidents" },
  { to: "/incontinence", label: "Protections incontinence" },
  { to: "/suivi-commercial", label: "Suivi commercial" },
  { to: "/formation", label: "Formation du personnel" },
];
// Rôles assignables par l'administrateur principal
export const ASSIGNABLE_ROLES = [...FULL_ACCESS_ROLES, ...COMMERCIAL_ROLES, ...SOCIAL_LIFE_ROLES, ...CARE_ROLES, ...PARTNER_ROLES, ...PROFESSIONAL_ROLES, ...KITCHEN_ROLES];

export const PRIORITY = {
  urgent: { label: "Urgent", text: "#fca5a5", bg: "rgba(239,68,68,0.16)", dot: "#ef4444" },
  in_progress: { label: "En cours", text: "#fcd34d", bg: "rgba(245,158,11,0.16)", dot: "#f59e0b" },
  todo: { label: "À faire", text: "#cbd5e1", bg: "rgba(148,163,184,0.16)", dot: "#94a3b8" },
  closed: { label: "Clôturé", text: "#7dd3fc", bg: "rgba(14,165,233,0.16)", dot: "#0ea5e9" },
};

export const TASK_CATEGORIES = {
  urgent: "Urgent", appel: "Appel à rappeler", famille: "Famille à contacter",
  document: "Document à scanner", dossier: "Dossier résident", absence: "Absence / Certificat",
  livraison: "Livraison", facturation: "Facturation", direction: "Action direction", general: "Général",
};

export const FAMILY_TYPES = { appel: "Appel reçu", visite: "Visite", plainte: "Plainte", demande: "Demande", urgence: "Urgence" };
export const FAMILY_STATUS = {
  ouvert: { label: "Ouvert", text: "#fca5a5", bg: "rgba(239,68,68,0.16)" },
  en_cours: { label: "En cours", text: "#fcd34d", bg: "rgba(245,158,11,0.16)" },
  cloture: { label: "Clôturé", text: "#7dd3fc", bg: "rgba(14,165,233,0.16)" },
};
export const RESIDENT_STATUS = {
  actif: { label: "Actif", text: "#86efac", bg: "rgba(34,197,94,0.16)" },
  en_attente: { label: "En attente", text: "#fcd34d", bg: "rgba(245,158,11,0.16)" },
  sorti: { label: "Sorti", text: "#cbd5e1", bg: "rgba(148,163,184,0.16)" },
};
export const PROSPECT_STATUS = {
  nouveau: { label: "Nouveau", text: "#cbd5e1", bg: "rgba(148,163,184,0.16)" },
  contacte: { label: "Contacté", text: "#7dd3fc", bg: "rgba(14,165,233,0.16)" },
  visite_planifiee: { label: "Visite planifiée", text: "#c4b5fd", bg: "rgba(139,92,246,0.16)" },
  visite_faite: { label: "Visite faite", text: "#fcd34d", bg: "rgba(245,158,11,0.16)" },
  admis: { label: "Admis", text: "#86efac", bg: "rgba(34,197,94,0.16)" },
  refuse: { label: "Refusé", text: "#fca5a5", bg: "rgba(239,68,68,0.16)" },
};
export const URGENCY = {
  haute: { label: "Haute", text: "#fca5a5", bg: "rgba(239,68,68,0.16)" },
  normale: { label: "Normale", text: "#fcd34d", bg: "rgba(245,158,11,0.16)" },
  basse: { label: "Basse", text: "#cbd5e1", bg: "rgba(148,163,184,0.16)" },
};
export const SERVICES = ["coiffeur", "pédicure", "transport", "kiné", "repas spécial"];

export const HR_TYPES = {
  nouveau_contrat: "Nouveau contrat", avenant: "Avenant", changement_adresse: "Changement adresse",
  changement_banque: "Changement banque", etat_civil: "État civil", badge: "Badge",
  certificat_medical: "Certificat médical", absence_injustifiee: "Absence injustifiée",
  reprise_partielle: "Reprise partielle", interim: "Intérim", document_a_scanner: "Document à scanner",
};
export const HR_STATUS = {
  a_faire: { label: "À faire", text: "#cbd5e1", bg: "rgba(148,163,184,0.16)" },
  en_cours: { label: "En cours", text: "#fcd34d", bg: "rgba(245,158,11,0.16)" },
  cloture: { label: "Clôturé", text: "#86efac", bg: "rgba(34,197,94,0.16)" },
};
export const INVOICE_STATUS = {
  preparee: { label: "Préparée", text: "#7dd3fc", bg: "rgba(14,165,233,0.16)" },
  element_manquant: { label: "Élément manquant", text: "#fca5a5", bg: "rgba(239,68,68,0.16)" },
  correction: { label: "Correction", text: "#fcd34d", bg: "rgba(245,158,11,0.16)" },
  validation_direction: { label: "Validation direction", text: "#c4b5fd", bg: "rgba(139,92,246,0.16)" },
  envoyee: { label: "Envoyée", text: "#86efac", bg: "rgba(34,197,94,0.16)" },
  non_envoyee: { label: "Non envoyée", text: "#cbd5e1", bg: "rgba(148,163,184,0.16)" },
};
export const COURRIER_TYPES = {
  courrier_recu: "Courrier reçu", courrier_distribue: "Courrier distribué",
  email_important: "E-mail important", colis_livre: "Colis livré", probleme_fournisseur: "Problème fournisseur",
};
export const COURRIER_STATUS = {
  a_faire: { label: "À traiter", text: "#fca5a5", bg: "rgba(239,68,68,0.16)" },
  traite: { label: "Traité", text: "#86efac", bg: "rgba(34,197,94,0.16)" },
};
export const QUALITY_STATUS = {
  ouvert: { label: "Ouvert", text: "#fca5a5", bg: "rgba(239,68,68,0.16)" },
  en_cours: { label: "En cours", text: "#fcd34d", bg: "rgba(245,158,11,0.16)" },
  resolu: { label: "Résolu", text: "#86efac", bg: "rgba(34,197,94,0.16)" },
};
export const EVENT_CATEGORIES = {
  rdv: { label: "Rendez-vous", color: "#6366f1" },
  reunion: { label: "Réunion", color: "#ec4899" },
  visite: { label: "Visite", color: "#10b981" },
  tache: { label: "Tâche", color: "#f59e0b" },
  autre: { label: "Autre", color: "#94a3b8" },
};

export const MODULES = [
  { to: "/", label: "Tableau de bord", icon: "LayoutDashboard", color: "#6366f1" },
  { to: "/agenda", label: "Agenda", icon: "CalendarDays", color: "#3b82f6" },
  { to: "/residents", label: "Résidents", icon: "Users", color: "#10b981" },
  { to: "/incontinence", label: "Protections incontinence", icon: "ShieldPlus", color: "#0ea5e9" },
  { to: "/formation", label: "Formation du personnel", icon: "GraduationCap", color: "#a855f7" },
  { to: "/suivi-commercial", label: "Suivi commercial", icon: "TrendingUp", color: "#059669" },
];

export const CRM_STATUS = {
  nouveau: { label: "Nouveau contact", text: "#cbd5e1", bg: "rgba(148,163,184,0.16)" },
  a_rappeler: { label: "À rappeler", text: "#fca5a5", bg: "rgba(239,68,68,0.16)" },
  infos_envoyees: { label: "Infos envoyées", text: "#7dd3fc", bg: "rgba(14,165,233,0.16)" },
  visite_proposee: { label: "Visite proposée", text: "#7dd3fc", bg: "rgba(14,165,233,0.16)" },
  visite_planifiee: { label: "Visite planifiée", text: "#c4b5fd", bg: "rgba(139,92,246,0.16)" },
  visite_faite: { label: "Visite réalisée", text: "#fcd34d", bg: "rgba(245,158,11,0.16)" },
  dossier_analyse: { label: "Dossier en analyse", text: "#fcd34d", bg: "rgba(245,158,11,0.16)" },
  admission_possible: { label: "Admission possible", text: "#c4b5fd", bg: "rgba(139,92,246,0.16)" },
  admission_confirmee: { label: "Admission confirmée", text: "#86efac", bg: "rgba(34,197,94,0.16)" },
  entree_programmee: { label: "Entrée programmée", text: "#86efac", bg: "rgba(34,197,94,0.16)" },
  entre: { label: "Entré", text: "#34d399", bg: "rgba(16,185,129,0.20)" },
  refus_famille: { label: "Refus famille", text: "#fca5a5", bg: "rgba(239,68,68,0.16)" },
  non_adapte: { label: "Non adapté", text: "#fca5a5", bg: "rgba(239,68,68,0.16)" },
  perdu: { label: "Perdu", text: "#94a3b8", bg: "rgba(148,163,184,0.16)" },
  recontacter: { label: "À recontacter plus tard", text: "#cbd5e1", bg: "rgba(148,163,184,0.16)" },
};
export const CRM_HEAT = {
  froid: { label: "Froid", text: "#93c5fd", bg: "rgba(59,130,246,0.16)", dot: "#3b82f6" },
  tiede: { label: "Tiède", text: "#fcd34d", bg: "rgba(245,158,11,0.16)", dot: "#f59e0b" },
  chaud: { label: "Chaud", text: "#fb923c", bg: "rgba(249,115,22,0.16)", dot: "#f97316" },
  tres_chaud: { label: "Très chaud", text: "#fca5a5", bg: "rgba(239,68,68,0.18)", dot: "#ef4444" },
  confirme: { label: "Confirmé", text: "#86efac", bg: "rgba(34,197,94,0.18)", dot: "#22c55e" },
};
export const CRM_ROOM_STATUS = {
  libre: { label: "Libre", text: "#86efac", bg: "rgba(34,197,94,0.16)", dot: "#22c55e" },
  bientot: { label: "Bientôt disponible", text: "#7dd3fc", bg: "rgba(14,165,233,0.16)", dot: "#0ea5e9" },
  preparation: { label: "En préparation", text: "#fcd34d", bg: "rgba(245,158,11,0.16)", dot: "#f59e0b" },
  partiellement: { label: "Partiellement occupée", text: "#fdba74", bg: "rgba(249,115,22,0.16)", dot: "#fb923c" },
  reservee: { label: "Réservée", text: "#c4b5fd", bg: "rgba(139,92,246,0.16)", dot: "#8b5cf6" },
  occupee: { label: "Occupée", text: "#cbd5e1", bg: "rgba(148,163,184,0.16)", dot: "#94a3b8" },
};
export const CRM_SOURCES = ["Google", "Bouche-à-oreille", "Hôpital", "Médecin", "Assistant social", "CPAS", "Mutuelle", "Famille déjà présente", "Site web", "Réseau personnel", "Autre résidence", "Autre"];
export const CRM_URGENCY = { immediat: "Immédiat", semaine: "Dans la semaine", mois: "Dans le mois", renseignement: "Simple renseignement", futur: "Projet futur" };
export const CRM_SITUATION = { domicile: "Domicile", hopital: "Hôpital", revalidation: "Centre de revalidation", autre_mr: "Autre maison de repos", court_sejour: "Court séjour", famille: "Famille" };
export const CRM_RELATION = { fils: "Fils", fille: "Fille", conjoint: "Conjoint(e)", tuteur: "Tuteur", admin_biens: "Administrateur de biens", assistant_social: "Assistant social", autre: "Autre" };
export const CRM_MOBILITY = { autonome: "Autonome", canne: "Canne", rollator: "Rollator", chaise: "Chaise roulante", alite: "Alité(e)" };
export const CRM_CONTINENCE = { continent: "Continent", protections: "Protections", urinaire: "Incontinence urinaire", fecale: "Incontinence fécale" };
export const CRM_COGNITIVE = { aucun: "Aucun", legers: "Légers", moderes: "Modérés", severes: "Sévères" };
export const CRM_ROOM_TYPES = { simple: "Chambre simple", double: "Chambre double", unite_protegee: "Unité protégée" };
export const CRM_STAY_TYPES = { long: "Long séjour", court: "Court séjour", convalescence: "Convalescence" };
export const CRM_OCCUPANCY = { 0: "0 résident (vide)", 1: "1 résident", 2: "2 résidents (complet)" };
export const CRM_VISIT_STATUS = {
  planifiee: { label: "Planifiée", text: "#c4b5fd", bg: "rgba(139,92,246,0.16)", dot: "#8b5cf6" },
  faite: { label: "Réalisée", text: "#86efac", bg: "rgba(34,197,94,0.16)", dot: "#22c55e" },
  reportee: { label: "Reportée", text: "#fcd34d", bg: "rgba(245,158,11,0.16)", dot: "#f59e0b" },
  annulee: { label: "Annulée", text: "#fca5a5", bg: "rgba(239,68,68,0.16)", dot: "#ef4444" },
};
export const CRM_CHANNELS = { tel: "Appel téléphonique", email: "E-mail", sms: "SMS", courrier: "Courrier", visite: "Visite", autre: "Autre" };
export const CRM_ADMISSION_STATUS = {
  dossier_ouvert: { label: "Dossier ouvert", text: "#cbd5e1", bg: "rgba(148,163,184,0.16)", dot: "#94a3b8" },
  en_constitution: { label: "En constitution", text: "#7dd3fc", bg: "rgba(14,165,233,0.16)", dot: "#0ea5e9" },
  complet: { label: "Dossier complet", text: "#fcd34d", bg: "rgba(245,158,11,0.16)", dot: "#f59e0b" },
  valide: { label: "Validé direction", text: "#c4b5fd", bg: "rgba(139,92,246,0.16)", dot: "#8b5cf6" },
  entree_confirmee: { label: "Entrée confirmée", text: "#86efac", bg: "rgba(34,197,94,0.16)", dot: "#22c55e" },
  entre: { label: "Entré", text: "#34d399", bg: "rgba(16,185,129,0.20)", dot: "#10b981" },
  annule: { label: "Annulé", text: "#fca5a5", bg: "rgba(239,68,68,0.16)", dot: "#ef4444" },
};
export const CRM_PARTNER_TYPES = { hopital: "Hôpital", medecin: "Médecin traitant", assistant_social: "Assistant social", cpas: "CPAS", mutuelle: "Mutuelle", maison_repos: "Autre maison de repos", revalidation: "Centre de revalidation", autre: "Autre" };

// Navigation autorisée selon le rôle
const HISTORIQUE_ITEM = { to: "/historique", label: "Historique", icon: "History", color: "#0ea5e9" };
export function navForRole(role) {
  const PP_ITEM = { to: "/suivi-pp", label: "Suivi Projet Personnalisé", icon: "ClipboardCheck", color: "#0d9488" };
  const PP_DASH_ITEM = { to: "/tableau-pp", label: "Tableau de bord Projet Personnalisé", icon: "LayoutDashboard", color: "#14b8a6" };
  const RECO_ITEM = { to: "/recommandations", label: "Recommandations", icon: "Sparkles", color: "#f59e0b" };
  const DOMAINS_ITEM = { to: "/domaines-pp", label: "Domaines de vie", icon: "Tags", color: "#6366f1" };
  const OBJTYPES_ITEM = { to: "/objectifs-types-pp", label: "objectifsPP", icon: "Target", color: "#0d9488" };
  const CATEGORIES_ITEM = { to: "/categories-activites", label: "Catégories d'activités", icon: "Tags", color: "#14b8a6" };
  const VIE_SOCIALE_ITEM = { to: "/vie-sociale", label: "Vie sociale", icon: "Activity", color: "#14b8a6" };
  // Admin principal : Utilisateurs + Catégories d'activités + Historique (+ Guide via lien en bas de la sidebar).
  if (role === "admin") return [
    { to: "/utilisateurs", label: "Utilisateurs", icon: "Users2", color: "#64748b" },
    CATEGORIES_ITEM,
    HISTORIQUE_ITEM,
  ];
  // CEO : mêmes onglets que l'attaché clientèle + accès à toutes les maisons, mais en LECTURE SEULE.
  if (role === "ceo") return [...MODULES.filter((m) => COMMERCIAL_PATHS.includes(m.to)), HISTORIQUE_ITEM];
  if (CARE_ROLES.includes(role)) return [...MODULES.filter((m) => CARE_PATHS.includes(m.to)), PP_ITEM, PP_DASH_ITEM, RECO_ITEM];
  // Directeur / Directeur adjoint : Tableau de bord, Agenda, Vie sociale, Suivi commercial, Cuisine, Messagerie, Historique (+ Guide en bas).
  if (role === "directeur" || role === "directeur_adjoint") return [
    ...MODULES.filter((m) => m.to === "/" || m.to === "/agenda"),
    VIE_SOCIALE_ITEM,
    ...MODULES.filter((m) => m.to === "/suivi-commercial"),
    ...CUISINE_ITEMS,
    MESSAGERIE_ITEM,
    HISTORIQUE_ITEM,
  ];
  // Attaché clientèle : accès complet au groupe (Tableau de bord, Agenda, Suivi commercial) + Historique.
  if (COMMERCIAL_ROLES.includes(role)) return [...MODULES.filter((m) => COMMERCIAL_PATHS.includes(m.to)), MESSAGERIE_ITEM, HISTORIQUE_ITEM];
  if (PARTNER_ROLES.includes(role)) return [{ to: "/espace-partenaires", label: "Espace Partenaires", icon: "DoorOpen", color: "#059669" }];
  // Rôles Paramédical / Soins ET Vie sociale (Directeur / Coordinateur vie sociale) : menu identique.
  // Agenda, Planning activité, Domaine de vie, Vie sociale, Suivi PP, Tableau de bord PP, Recommandations, Messagerie (+ Guide en bas).
  const SOINS_SOCIAL_NAV = [
    ...MODULES.filter((m) => m.to === "/agenda"),
    PLANNING_MODULE,
    DOMAINS_ITEM,
    OBJTYPES_ITEM,
    VIE_SOCIALE_ITEM,
    PP_ITEM,
    PP_DASH_ITEM,
    RECO_ITEM,
    MESSAGERIE_ITEM,
  ];
  if (SOCIAL_LIFE_ROLES.includes(role)) return SOINS_SOCIAL_NAV;
  // Rôles cuisine : uniquement le module Cuisine + Messagerie.
  if (KITCHEN_ROLES.includes(role)) return [...CUISINE_ITEMS, MESSAGERIE_ITEM];
  // Rôles pro avec accès Cuisine (logopède, ergo, diététicien, aide-soignant, infirmier) : menu pro + Cuisine.
  if (PROFESSIONAL_ROLES.includes(role)) {
    if (CUISINE_PRO_ROLES.includes(role)) return [...SOINS_SOCIAL_NAV.slice(0, -1), ...CUISINE_ITEMS, MESSAGERIE_ITEM];
    return SOINS_SOCIAL_NAV;
  }
  // Repli : accès complet à leur maison (+ Formation).
  let base = MODULES.filter((m) => !CARE_PATHS.includes(m.to));
  if (!FORMATION_ROLES.includes(role)) base = base.filter((m) => m.to !== "/formation");
  base = [...base, { to: "/vie-sociale", label: "Vie sociale", icon: "Activity", color: "#14b8a6" }, MESSAGERIE_ITEM];
  return base;
}
export const allowedPaths = (role) => {
  const p = navForRole(role).map((m) => m.to);
  return p;
};

// Nav enrichie des droits par exception (modules supplémentaires accordés à un utilisateur précis)
export function navForUser(user) {
  const base = navForRole(user?.role);
  const extra = user?.extra_allowed_paths || [];
  if (!extra.length) return base;
  const have = new Set(base.map((m) => m.to));
  const extraModules = extra
    .filter((p) => !have.has(p))
    .map((p) => MODULES.find((m) => m.to === p) || (p === "/planning-activite" ? PLANNING_MODULE : null))
    .filter(Boolean);
  return [...base, ...extraModules];
}
export const allowedPathsForUser = (user) => {
  const p = navForUser(user).map((m) => m.to);
  return p;
};

export const homePathForRole = (role) => (role === "admin" ? "/utilisateurs" : PARTNER_ROLES.includes(role) ? "/espace-partenaires" : KITCHEN_ROLES.includes(role) ? "/cuisine-agenda" : SOCIAL_LIFE_ROLES.includes(role) ? "/agenda" : PROFESSIONAL_ROLES.includes(role) ? "/agenda" : CARE_ROLES.includes(role) ? "/residents" : "/");

export const FORMATION_CATEGORIES = [
  "Soins AS_INFI", "KEL", "PRR", "Médecin coordinateur",
  "Administration", "Hôtellerie", "Entretien et maintenance", "Direction",
];

export const FORMATION_FONCTIONS = [
  "AS", "INFI", "Infirmier en chef", "Infirmier coordinateur", "Kiné", "Logo", "Ergo",
  "Educ/Anim", "Référent démence", "MCC", "Médecin coordinateur",
  "Nettoyage", "Cuisinier", "Chef Cuisine", "Lingerie",
  "Directeur", "Directrice Adjointe", "Hôte(sse) d'accueil", "Attaché clientèle",
  "Administratif", "Technicien / Maintenance",
];

export const FORMATION_THEMES = [
  "Bientraitance et relations avec les aînés",
  "Gériatrie",
  "Diversité (multiculturalité, identité des genres, orientations sexuelles,…)",
  "Qualité des soins et la démarche d'amélioration continue",
  "Accompagnement et la participation des aînés",
  "Relations internes aux équipes de travail",
  "Fin de vie",
  "Accompagnements des habitants atteints des troubles cognitifs majeurs ou de démence",
  "Incendie",
  "Alimentation",
  "Bilinguisme",
  "Entretien",
  "Prévention",
  "Sécurité",
  "Hygiène alimentaire",
];

// Thèmes spécifiques Médecin coordinateur (formation libre, pas de liste pré-remplie)
export const FORMATION_THEMES_MEDCOORD = [
  "Gériatrie", "Soins palliatifs", "Fin de vie", "Gestion de crise",
  "Évolution des règlementations (liées à ces sujets)",
];

// Correspondance Thème obligatoire -> formations proposées (issue du plan IrisCare / Femarbel)
export const FORMATION_BY_THEME = {
  "Bientraitance et relations avec les aînés": [
    "Communication avec une personne atteinte de troubles cognitifs",
    "La démence : Accompagner en cas de crise",
    "Maltraitance – Bientraitance",
    "La triade soignant / soigné / famille : La communication",
    "Ecoute active",
  ],
  "Gériatrie": [
    "Plaie de decubitus", "L'arthrose", "Dégénérescence maculaire liée à l'âge",
    "Le glaucome", "La cataracte", "La déshydratation", "L'ostéoporose",
    "La malnutrition", "La dépression", "l'Hygiène bucco-dentaire", "L'incontinence",
  ],
  "Diversité (multiculturalité, identité des genres, orientations sexuelles,…)": [
    "EVRAS : en attente",
  ],
  "Qualité des soins et la démarche d'amélioration continue": [
    "La qualité", "Le projet de vie", "Les outils de la qualité : La communication",
    "Les outils de la qualité : L'analyse", "Les outils de la qualité : L'amélioration continue",
    "Les outils de la qualité : La standardisation", "Les outils de la qualité : La mise en place",
    "Prévention des chutes", "Malnutrition", "Mesures de contentions", "Transmissions ciblées",
    "Les KPI's", "La planification anticipées de soins", "Le secret professionnel",
    "Hygiène bucco-dentaire", "L'incontinence", "L'hygiène des mains",
  ],
  "Accompagnement et la participation des aînés": [
    "La démence : Accompagner en cas de crise", "Les soins palliatifs",
    "Projet de vie", "Planification anticipée de soins",
  ],
  "Relations internes aux équipes de travail": ["Le bien-être au travail"],
  "Fin de vie": ["Les soins palliatifs", "La planification anticipée de soins"],
  "Accompagnements des habitants atteints des troubles cognitifs majeurs ou de démence": [
    "La démence", "La démence : accompagner en cas de crise",
    "Communication avec une personne atteinte de troubles neurocognitifs",
  ],
  "Incendie": ["Prévention incendie"],
  "Alimentation": ["Les allergènes", "Malnutrition", "La déshydratation"],
  "Bilinguisme": ["Néant"],
  "Entretien": ["L'entretien des locaux", "La bio-révolution du nettoyage"],
  "Prévention": [
    "Vaccination grippe", "La vaccination Covid", "Manutention & ergonomie",
    "Manutention et positions correctes", "Manutention et soins - Règles, attitudes, prises, aides",
  ],
  "Sécurité": ["Signalisation de sécurité", "Évacuation", "Premiers secours"],
  "Hygiène alimentaire": [
    "Le lavage des mains", "L'entretien des locaux", "La bio-révolution du nettoyage",
    "Les allergènes", "La contamination croisée", "Microbiologie en alimentation",
    "HACCP : Introduction", "HACCP : Autocontrôle", "HACCP : Exigence d'hygiène",
    "HACCP : Les Bonnes Pratiques d'Hygiène (BPH)", "HACCP : Règles d'hygiène spécifiques à la préparation",
    "HACCP : Processus 1- 4", "HACCP : Processus 5- 8", "HACCP : Processus 9- 12",
    "HACCP : Processus 13- 16", "HACCP : Processus 17- 20",
  ],
};

export const FORMATION_ORGANISMES = [
  "E-learning Femarbel", "Solform", "A-First", "Cesi", "Repère", "Serenity (interne)",
  "JFC Femarbel", "Croix-Rouge", "Autre",
];

// Obligation légale (Bruxelles / IrisCare) + cible annuelle utilisée pour le suivi
export const FORMATION_OBLIGATIONS = {
  "Soins AS_INFI": { target: 20, text: "min 40h / 2 ans (dont 8h/an)", color: "#10b981" },
  "KEL": { target: 20, text: "min 40h / 2 ans (dont 8h/an)", color: "#10b981" },
  "PRR": { target: 20, text: "min 40h / 2 ans (dont 8h/an)", color: "#10b981" },
  "Médecin coordinateur": { target: 6, text: "12h / 2 ans", color: "#06b6d4" },
  "Administration": { target: 8, text: "min 16h / 2 ans (dont 4h/an)", color: "#f59e0b" },
  "Hôtellerie": { target: 8, text: "min 16h / 2 ans (dont 4h/an)", color: "#f59e0b" },
  "Entretien et maintenance": { target: 8, text: "min 16h / 2 ans (dont 4h/an)", color: "#f59e0b" },
  "Direction": { target: 24, text: "min 24h / an", color: "#ec4899" },
};
